// extracted by mini-css-extract-plugin
export default {"root":"BetaBadge_root__5gU05"};